import React, { FC } from 'react'
import TextField from '@mui/material/TextField'
import { StaticDatePicker } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { ja } from 'date-fns/locale'
import styled from 'styled-components'
import { initialDatePickerState } from '../../constants/context/datePicker'
import { useCalendarContext } from '../../context/calendar'
import renderPickerDay from './renderPickerDay'
import renderWeekPickerDay from './renderWeekPickerDay'

const StaticDatePickerWrapper = styled.div`
  & .MuiDayPicker-weekContainer {
    button:hover {
      background: #a9ec8a80;
    }
    & .Mui-selected button:hover {
      background: #a9ec8a80;
    }
  }
`

const DatePicker: FC = () => {
  const { date, mode, setDate } = useCalendarContext()

  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={ja}
      dateFormats={{ monthAndYear: 'yyyy年MM月' }}
    >
      <StaticDatePickerWrapper>
        <StaticDatePicker
          disableHighlightToday
          displayStaticWrapperAs="desktop"
          value={date}
          onChange={(newDate) => setDate(newDate ?? initialDatePickerState.date)}
          renderDay={mode === 'week' ? renderWeekPickerDay(date) : renderPickerDay}
          renderInput={(params) => <TextField {...params} />}
        />
      </StaticDatePickerWrapper>
    </LocalizationProvider>
  )
}

export default DatePicker
